module.exports = __webpack_public_path__ + "static/media/aaron-skonnard2.c5188e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/aaron-skonnard2.jpg
// module id = 184
// module chunks = 0